
import { DiaryEntry } from "@/utils/generator";
import { useLanguage } from "@/contexts/language";
import { useState, useEffect } from "react";
import { t } from "@/utils/translations";
import EntryImageGallery from "./content/EntryImageGallery";
import EntryText from "./content/EntryText";
import EntryTranslator from "./content/EntryTranslator";

interface EntryCardContentProps {
  entry: DiaryEntry;
  expanded: boolean;
  toggleExpand: () => void;
  displayText: string;
  displayPreviewText: string;
}

const EntryCardContent = ({
  entry,
  expanded,
  toggleExpand,
  displayText,
  displayPreviewText
}: EntryCardContentProps) => {
  const { language } = useLanguage();
  const [isTranslating, setIsTranslating] = useState(false);
  const [translatedContent, setTranslatedContent] = useState<string | null>(null);
  
  // Reset translation state when language changes
  useEffect(() => {
    setIsTranslating(language !== 'en');
  }, [language]);
  
  // Determine which text to display based on translation state
  const finalDisplayText = isTranslating && !translatedContent 
    ? t('common.translating', language) 
    : (translatedContent || displayText);
    
  const finalDisplayPreviewText = isTranslating && !translatedContent 
    ? t('common.translating', language) 
    : translatedContent 
      ? (translatedContent.length > 150 ? translatedContent.substring(0, 150) + "..." : translatedContent)
      : displayPreviewText;
  
  return (
    <div>
      <EntryImageGallery entry={entry} />
      
      <EntryTranslator
        entry={entry} 
        setTranslatedContent={(content) => {
          setTranslatedContent(content);
          setIsTranslating(false);
        }}
      />
      
      <EntryText
        isTranslating={isTranslating}
        finalDisplayText={finalDisplayText}
        finalDisplayPreviewText={finalDisplayPreviewText}
        expanded={expanded}
        toggleExpand={toggleExpand}
      />
    </div>
  );
};

export default EntryCardContent;
